import { mPerLat, mPerLon } from './geo';
// field geometry + orchard/row and landscaping quantities
const rad = Math.PI / 180;
const n = (v, d) => (v === '' || v == null || !Number.isFinite(+v) ? d : +v);

export function geom(pts) {
  const la = pts.reduce((s, p) => s + p[0], 0) / pts.length, k = mPerLon(la);
  const P = pts.map((p) => [p[1] * k, p[0] * mPerLat(la)]);
  let A = 0, per = 0, L = 0;
  P.forEach((p, i) => { const q = P[(i + 1) % P.length], e = Math.hypot(q[0] - p[0], q[1] - p[1]); A += p[0] * q[1] - q[0] * p[1]; per += e; L = Math.max(L, e); });
  return { A: Math.abs(A) / 2, per, L };
}

export const ROW_DEF = { rs: 3.5, ps: 1, post: 8, drip: 5, foil: 10, fence: 3 };
export function rowCalc(pts, c = {}) {
  const { A, per, L } = geom(pts);
  const rs = n(c.rs, ROW_DEF.rs), ps = n(c.ps, ROW_DEF.ps), post = n(c.post, ROW_DEF.post);
  const rowLen = n(c.rowLen, L), rows = n(c.rows, Math.max(1, Math.round(A / rowLen / rs)));
  const total = rows * rowLen;
  return {
    A, per, rows, rowLen, total,
    plants: rows * (Math.floor(rowLen / ps) + 1),
    endPosts: rows * 2, anchors: rows * 2, midPosts: rows * Math.max(0, Math.ceil(rowLen / post) - 1),
    drip: total * (1 + n(c.drip, ROW_DEF.drip) / 100), main: rows * rs,
    net: total * rs * (1 + n(c.foil, ROW_DEF.foil) / 100),
    fence: per, fencePosts: Math.ceil(per / n(c.fence, ROW_DEF.fence)),
  };
}

export const LAND = { turf: { waste: 5 }, topsoil: { cm: 20, t: 1.6 }, mulch: { cm: 7, t: 0.35 }, gravel: { cm: 10, t: 1.7 }, paving: { waste: 3 } };
export const PCT = { turfPct: 100, topsoilPct: 100, mulchPct: 0, gravelPct: 0, pavingPct: 0 };
export function landCalc(pts, c = {}) {
  const { A, per } = geom(pts), sh = (k) => (n(c[k], PCT[k]) / 100) * A;
  const vol = (k) => { const m3 = sh(k + 'Pct') * n(c[k + 'Cm'], LAND[k].cm) / 100; return { m3, t: m3 * LAND[k].t }; };
  return { A, per, turf: sh('turfPct') * (1 + LAND.turf.waste / 100), topsoil: vol('topsoil'), mulch: vol('mulch'), gravel: vol('gravel'), paving: sh('pavingPct') * (1 + LAND.paving.waste / 100), edging: per };
}
